import useMediaQuery from "@mui/material/useMediaQuery";
import { createTheme } from "@mui/material/styles";
import NavbarMobile from "./navbar-mobile";

import { ICategoria } from "../../interfaces/produto/categoria";

export default function FooterPimaco(props: { categorias: ICategoria[] }) {
  const theme = createTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <footer>
      {!matches && <NavbarMobile categorias={props.categorias} />}
      <div className="footer-credits-container">
        <p>&copy; Pimaco 2024. Powered by Beontag</p>
        <div>
          <p style={{ marginTop: 0, fontSize: 10 }}>{process.env.REACT_APP_APP_VERSION}</p>
        </div>
      </div>
    </footer>
  );
}
